import { ImportSong, ImportStatusType } from './types';

export const readCSV = (
  file?: File,
  onLoad?: (csvText: string | ArrayBuffer) => void
) => {
  if (file) {
    const fileReader = new FileReader();
    fileReader.onload = (event) => {
      const csvText = event.target?.result || '';
      onLoad?.(csvText);
    };

    fileReader.readAsText(file);
  }
};

const isVisibleFileName = (title: string) => !title.startsWith('.');

export const filesToImportSongs = (files: File[]) => {
  const songTitleIndex = files.reduce((acc, item) => {
    const index = item?.path
      ?.split('/')
      .findIndex((i) => ['Recordings', 'lyrics.txt'].includes(i));
    if (index > -1) {
      return index - 1;
    }
    return acc;
  }, -1);

  if (songTitleIndex < 0) {
    return [];
  }

  return Object.values(
    files.reduce((acc, file) => {
      const songTitle = file.path.split('/')[songTitleIndex];
      if (songTitle && isVisibleFileName(songTitle) && !acc[songTitle]) {
        acc[songTitle] = {
          songTitle,
          audios: [],
        };
      }
      if (file.path.includes('/Master/') && isVisibleFileName(file.name)) {
        acc[songTitle].audios.push({
          audioTitle: file.name.trim(),
          file,
          loading: true,
        });
      }
      if (file.name === 'lyrics.txt') {
        acc[songTitle].lyrics = {
          file,
          loading: true,
        };
      }
      return acc;
    }, {})
  ) as ImportSong[];
};

export const getMessageByStatus = (status?: ImportStatusType): string => {
  if (status === 'success') {
    return 'All songs audios have been uploaded';
  }
  if (status === 'inconsistent') {
    return "Some songs didn't match songs meta data";
  }
  if (status === 'failed') {
    return 'Failed to upload some songs audios or lyrics';
  }
  return '';
};

export const isSongsFolderHasCorrectStructure = (file: File[]) => {
  const pathRegex = new RegExp('.*/(Recordings/[^/]+/Master/.*|lyrics.txt)');

  return file.some(({ path }) => pathRegex.test(path));
};
